import { Pipe, PipeTransform } from '@angular/core';
import { IUserForDropdown } from '@shared/services/api/legacy/users-service/user-model';

@Pipe({
  name: 'ownerPipe',
  pure: false
})
export class OwnerPipe implements PipeTransform {

  public transform(usersForDropdown: IUserForDropdown[], ownerId: string): string {
    let ownerName = '';
    if (usersForDropdown.find(x => x.id === ownerId)) {
      ownerName = usersForDropdown.find(x => x.id === ownerId).text;
    }
    return ownerName;
  }

}
